<template>
  <div class="">
    <div class="container header">
      <a href="/"><img
        src="../assets/img/logo.svg"
        alt="Ludimos"
      ></a>
    </div>
    <div class="section-background">
      <div class="container">
        <div class="hero">
          <div class="text">
            <p class="sub-title">
              Player empowerment starts here
            </p>

            <h1 class="title">
              Get your coaching account
            </h1>
            <div class="trial-form">
              <h4>
                Fill in the form and pick a time where one of our team member will 
                introduce, demonstrate and set up your Ludimos coaching account.
              </h4>
              <br>
              <div class="form">
                <div v-if="!showCalendar">
                  <img
                    src="../assets/img/ludimos-dashboard.png"
                    alt="dashboard"
                    class="image"
                  >
                  <b-form
                    v-if="show"
                    @submit.prevent
                  >
                    <b-form-group
                      id="input-group-name"
                      label="Name"
                      label-for="input-name"
                    >
                      <b-form-input
                        id="input-name"
                        v-model="form.name"
                        required
                        :state="nameState"
                        placeholder="John Doe"
                      />
                    </b-form-group>

                    <b-form-group
                      id="input-group-email"
                      label-for="input-email"
                      label="Email"
                    >
                      <b-form-input
                        id="input-email"
                        v-model="form.email"
                        :state="emailState"
                        type="email"
                        required
                        placeholder="john@doe.com"
                      />
                    </b-form-group>
                    <br>
                    <br>

                    <b-form-group
                      id="input-group-club"
                      label-for="input-club"
                      label="Club, School or Academy name"
                    >
                      <b-form-input
                        id="input-club"
                        v-model="form.club_name"
                        :state="clubState"
                        required
                        placeholder="AB Cricket Academy"
                      />
                    </b-form-group>

                    <b-form-group
                      id="input-group-clubsize"
                      label-for="input-clubsize"
                      label="How many players do you coach?"
                    >
                      <b-form-select
                        id="input-clubsize"
                        v-model="form.club_size"
                        :state="clubSizeState"
                        :options="clubSizes"
                        required
                      />
                    </b-form-group>
                    <!-- <b-form-group
                      id="input-group-role"
                      label-for="input-role"
                      label="Your role"
                    >
                      <b-form-select
                        id="input-role"
                        v-model="form.role"
                        :state="roleState"
                        :options="roles"
                        required
                      />
                    </b-form-group> -->
                    <br>
                    <br>

                    <b-form-group
                      id="input-group-phonenumber"
                      label-for="input-phonenumber"
                      label="Phonenumber"
                    >
                      <b-form-input
                        id="input-phonenumber"
                        v-model="form.phone"
                        type="number"
                        :state="phoneState"
                        placeholder="1234567890"
                        required
                      />
                    </b-form-group>
                    <b-form-group
                      id="input-group-role"
                      label-for="input-role"
                      label="Your role (optional)"
                    >
                      <b-form-select
                        id="input-role"
                        v-model="form.role"
                        :state="roleState"
                        :options="roles"
                      />
                    </b-form-group>
                    <b-form-group
                      id="input-group-country"
                      label-for="input-2country"
                      label="Country"
                    >
                      <b-form-input
                        id="input-country"
                        v-model="form.country"
                        :state="countryState"
                        placeholder="Where are you from?"
                        required
                      />
                    </b-form-group>
                  </b-form>
                  <br>
                  <b-button
                    :disabled="!formValid"
                    type="submit"
                    class="primary-button primary"
                    @click="onSubmit"
                  >
                    Pick a date
                  </b-button>
                </div>

                <vue-calendly
                  v-if="showCalendar"
                  :url="calendlyUrl"
                  :height="750"
                />
              </div>

              <div class="muted">
                <small>
                  By submitting this form, you confirm that you have read and
                  agree to our
                  <router-link
                    to="/terms"
                    class="link"
                    target="_blank"
                  >
                    Customer Terms of Service and Privacy Policy.
                  </router-link>
                </small>
              </div>
            </div>
          </div>
          <div class="visual effect">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="dashboard"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DemoService from "@/services/demoService";
export default {
  name: "RequestDemo",
  data() {
    return {
      showCalendar: false,
      form: {
        email: "",
        name: "",
        club_size: null,
        role: 'COACH',
        club_name: "",
        country: "",
        phone: "",
      },
      clubSizes: [
        // { text: "Number of players", value: null },
        { text: "10-25 players", value: "0-25" },
        { text: "26-50 players", value: "26-50" },
        { text: "51-100 players", value: "51-100" },
        { text: ">101 players", value: "101+" },
      ],
      roles: [
        // { text: "Your role", value: null },
        { text: "Coach", value: "COACH" },
        { text: "Admin/Manager", value: "ADMIN" },
        { text: "Player", value: "PLAYER" },
        { text: "Other", value: "OTHER" },
      ],
      show: true,
    };
  },
  computed: {
    calendlyUrl() {
      let url =
        "https://calendly.com/maaddy/intro?text_color=2b3060&primary_color=6f44ff";
      if (this.form.name) {
        url = `${url}&name=${this.form.name}`;
      }
      if (this.form.email) {
        url = `${url}&email=${this.form.email}`;
      }
      return url;
    },
    nameState() {
      return !this.form.name.length
        ? null
        : this.form.name.length > 1
        ? true
        : false;
    },
    emailState() {
      return !this.form.email ? null : this.validEmail(this.form.email);
    },
    clubState() {
      return !this.form.club_name.length
        ? null
        : this.form.club_name.length > 1
        ? true
        : false;
    },
    clubSizeState() {
      return !this.form.club_size
        ? null
        : this.form.club_size.length
        ? true
        : false;
    },
    roleState() {
      return !this.form.role ? null : this.form.role.length ? true : false;
    },
    countryState() {
      return !this.form.country
        ? null
        : this.form.country.length > 1
        ? true
        : false;
    },
    phoneState() {
      return !this.form.phone.length
        ? null
        : this.form.phone.length > 8
        ? true
        : false;
    },
    formValid() {
      if (
        !this.form.name ||
        !this.form.club_name ||
        !this.validEmail(this.form.email) ||
        !this.form.club_size ||
        !this.form.role ||
        !this.form.phone ||
        !this.form.country
      ) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    // Tracking code
    this.$ma.trackEvent({
      fb_event: "ViewContent",
      category: "Request_Demo",
      action: "Request_Demo",
      label: "DEMO",
      type: "DEMO",
    });
  },
  methods: {
    onReset() {
      this.form = {
        email: "",
        name: "",
        club_size: null,
        club_name: "",
        country: "",
        phone: "",
      };
    },
    async onSubmit() {
      this.showCalendar = true;
      if (this.formValid) {
        this.form.url_params = this.$route.query;
        DemoService.createRequest(this.form)
          .then(async (response) => {
            if (response.status === 201) {
              this.successful = true;
              this.$ma.trackEvent({
                fb_event: "Request_Demo",
                category: "Request_Demo",
                action: "Success",
                label: "Success",
                type: "Success",
                value: "1"
              });
              // this.$bvToast.toast("Request received successfully", {
              //   title: "Request Sucess",
              //   variant: "success",
              //   solid: true,
              //   toaster: "b-toaster-top-center",
              //   autoHideDelay: "3000",
              // });
              // await this.sleep(2000);

              // this.$router.push({ name: "request-demo-confirmation" });
            }
          })
          .catch(() => {
            this.successful = false;
            this.$ma.trackEvent({
              fb_event: "Request_Demo",
              category: "Request_Demo",
              action: "Fail",
              label: "Fail",
              type: "Fail",
            });
          });
      }
    },
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Ludimos - Start trial`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  },
};
</script>

<style lang="scss" scoped>
.section-background {
  padding: 50px 0;
}
.header {
  padding-top: 20px;
  a {
    img {
      max-width: 140px;
      opacity: 0.5;
      transition: all 0.3s ease-in-out;
    }
    &:hover {
      img {
        opacity: 1;
      }
    }
  }
}
.image {
  float: right;
  max-width: 400px;
}
.trial-form {
  .form {
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    .form-group {
      min-width: 300px;
      max-width: 400px;
      margin: 0 20px 20px 0;
      display: inline-block;
    }
  }
}
@media (max-width: 767px) {
  .image {
    display: none;
  }
  .trial-form {
    .form {
      .form-group {
        min-width: 100%;
        max-width: 100%;
        margin: 0 0 20px;
      }
    }
  }
}
</style>
